(function () {
    "use strict";

    function InterviewCalendarForm(scope, viewService, InterviewDataService, brandServices) {
        var self = this;
        var formName = "interview-calendar-form";
        var _protected = BaseForm.call(self, formName, scope);
        var _emitter = JarEventEmitter.call(self);

        self.data = {};
        self.data.replicate_type = '';
        self.data.copy_availability_weeks = 1;
        self.startDayOfWeek = 'MON';
        var interviewers = [];
        var slots = [];
        var interview_duration = 15;
        var interview_window;
        var allow_overlap = false;
        var isOptional = false;
        var dayFormat = "YYYY-MM-DD";

        self.durationTypesValues = {
            CUSTOM: 'CUSTOM'
        };

        self.setViewedWeek = function (weekStart) {
            var weekStartDate = getWeekStart(weekStart.startOf('day'), self.startDayOfWeek);

            self.onWeekSelected({
                from: weekStartDate.clone(),
                to: weekStartDate.clone().add(6, 'd')
            });
        };

        self.setDuration = function (duration) {
            interview_duration = parseInt(duration);
        };

        self.getDuration = function () {
            return interview_duration;
        };

        self.setInterviewWindow = function (interviewWindow) {
            interview_window = interviewWindow;
        };

        self.getInterviewWindow = function () {
            return self.data.interview_window;
        };

        self.setForcedTemplatesServiceEnabled = function (enabled) {
            self.isForcedTemplatesServiceEnabled = !!enabled;
        };


        self.load = function (formData, setData) {
            self.data.brandId = formData.brandId;
            self.data.job = formData.job;
            self.data.savingCopy = false;

            self.isInterviewV2Check = brandServices.check(brandServices.SERVICES.INTERVIEW_V2, formData.brandId);

            self.weekStartDate = getWeekStart(moment().startOf('day'), self.startDayOfWeek);
            self.weeklyRange = {
                from: self.weekStartDate.clone(),
                to: self.weekStartDate.clone().add(6, 'd')
            };

            self.showInterviewWindow = formData['showInterviewWindow'];

            if (setData) {
                allow_overlap = setData.allow_overlap || allow_overlap;
                interview_duration = (parseInt(setData.duration) / 60) || interview_duration;
                slots = angular.copy(setData.slots || slots);
                if (setData.interviewers) {
                    interviewers = angular.copy(setData.interviewers);
                } else {
                    if (self.data.job) {
                        var payload = {
                            types: ['PHONE', 'INVITE', 'SECOND_INVITE']
                        };
                        InterviewV2API.getJobInterviewers(self.data.brandId, self.data.job.id, payload)
                            .then(function (res) {
                                interviewers = angular.copy(res.interviewers || interviewers);
                            }).catch(function (err) {
                            console.error(err);
                        });
                    }
                }
            }


            if (setData && setData.duration) {
                self.hasDuration = true;
            }

            if ([15, 30, 60, 90, 120].indexOf(interview_duration) < 0) {
                self.data.interview_duration = 'CUSTOM';
                self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                self.data.custom_duration_minutes = String(interview_duration % 60);
            } else {
                self.data.interview_duration = String(interview_duration);
            }

            self.data.interview_window = self.showInterviewWindow ? interview_window : 365;
            self.updateInterviewWindow();

            if (setData && setData.slots && setData.slots.length) {
                InterviewDataService.parseData(self.weekStartDate, setData.slots, false, setData.applications);
            } else {
                InterviewDataService.parseData(self.weekStartDate, {});
            }

            for (var i in interviewers) {
                interviewers[i] = $.extend({}, interviewers[i].user);
            }

            viewService.init(self.weekStartDate);
            viewService.stepSize = interview_duration;


            // if there are no availabilities I want to draw here else after availabilities
            if (!interviewers.length) {
                viewService.drawAll();
            }

            self.initWeekPicker = true;
        };

        self.save = function () {
            var deferred = $q.defer();

            self.isSaving = true;
            if (self.validator.validate()) {
                deferred.resolve(self.data);
            } else {
                deferred.reject();
            }
            self.isSaving = false;

            return deferred.promise;
        };

        self.validator.validateCustom = function (field, optionsField, rule, showError) {

            var name = field.attr("name");
            var value = self.validator.getFieldValue(field);

            switch (rule.name) {
                case "slots":

                    if (self.isSaving && !InterviewDataService.hasFutureSlots() && !isOptional) {
                        self.validator.validation[name].errors[rule.name] = true;
                        return false;
                    }

                    break;

                case "required-if-not":
                    var dependantFieldValue = $("." + formName).find("select[name='" + rule.params[0] + "']").val();

                    if (dependantFieldValue == "0" && value == "0") {
                        self.validator.validation[name].errors[rule.name] = true;
                        return false;
                    } else {
                        delete self.validator.validation[name].errors[rule.name];

                        if (self.validator.validation[rule.params[0]]) {
                            delete self.validator.validation[rule.params[0]].errors[rule.name];
                        }
                    }

                    break;

                case "duration-time":
                    if (!self.data.custom_duration_minutes || !self.data.custom_duration_hours) {
                        return false;
                    }
                    break;

                case "past-week-date":
                    if (moment(self.data['ends_on_value']).isSameOrBefore(moment(self.weeklyRange.to.format("MMMM DD, YYYY")))) {
                        return false;
                    }

                    break;

                case "copy-slots":
                    var slots = self.getCopiedSlots();
                    if (!slots.length) {
                        self.validator.validation[name].errors[rule.name] = true;
                        return false;
                    }
                    break;
            }

            return true;
        };

        self.onWeekSelected = function (weekRange) {
            if (viewService && weekRange && self.initWeekPicker) {
                self.weeklyRange = weekRange;
                self.end_date_value = moment(self.weeklyRange.from).add(52, 'w').format("MMMM DD, YYYY");
                self.weekStartDate = getWeekStart(self.weeklyRange.from, self.startDayOfWeek);
                viewService.destroy();
                viewService.init(self.weekStartDate);


                if (interviewers.length) {
                    getInterviewersAvailabilities();
                } else {
                    InterviewDataService.resetAvailabilities();
                    viewService.clearGridAvailabilities();
                    viewService.drawAll();
                }
            }

        };

        InterviewDataService.on("interviewers_List_changed", function () {
            interviewers = InterviewDataService.interviewersList;
            if (interviewers.length) {
                getInterviewersAvailabilities();
            } else {
                InterviewDataService.resetAvailabilities();
                viewService.clearGridAvailabilities();
                viewService.init((moment(self.weekStartDate)));
                viewService.drawAll();
            }
            scope.$digest();
        });

        self.OnCopiedInterviewAvailableSlots = function () {
            self.data.savingCopy = true;
            if (self.validator.validate()) {
                if (interviewers.length) {
                    var savedSlots = self.getCopiedSlots();

                    // load interviewers' available and booked slots
                    // for the period ( from = current week first day  --- to : current week last day + 7 X NumberOfWeeksToCopy)
                    var availableSlotsPromise = returnCopiedPeriodAvailabilities("AVAILABLE");
                    var bookedSlotsPromise = returnCopiedPeriodAvailabilities("BOOKED");
                    var availabilityPromises = {
                        available: availableSlotsPromise,
                        booked: bookedSlotsPromise
                    };

                    $q.all(availabilityPromises)
                        .then(function (response) {
                            var bookedSlots = response.booked.interviewers;

                            // Make array of the new slots  (loop on the slots copied X NumberOfWeeksToCopy times ) and create new slots
                            var userIds = [];

                            for (var a in interviewers) {
                                var user = interviewers[a];
                                userIds.push(user.id);

                                // - loop on week slots
                                // - calculate number of weeks for that slot
                                // - loop on the calculated weeks
                                // - copy
                                for (var c = 0; c < savedSlots.length; c++) {
                                    if (self.data.replicate_type === 'ENDS_ON') {
                                        var diff = moment.duration(moment(self.data['ends_on_value']).diff(moment(savedSlots[c]['start_time'])));
                                        self.data.copy_availability_weeks = Math.floor(diff.asWeeks());
                                    } else if (self.data.replicate_type === 'NEVER_ENDS') {
                                        self.data.copy_availability_weeks = 25;
                                    }
                                    for (var N = 1; N <= self.data.copy_availability_weeks; N++) {
                                        var slot = savedSlots[c];
                                        var newSlotStart = (moment(slot['start_time']).add('d', 7 * (N))).valueOf();
                                        var newSlotEnd = (moment(slot['end_time']).add('d', 7 * (N))).valueOf();

                                        var userBooked = bookedSlots.find(function (bookedSlot) {
                                            return bookedSlot.user_id === user.id;
                                        });
                                        var userBookedSlots = (userBooked && userBooked.slots) || [];

                                        var newSlot = {
                                            id: "temp_" + N + '_' + Date.now(),
                                            start_time: newSlotStart,
                                            end_time: newSlotEnd,
                                            day: moment(newSlotStart).startOf().valueOf(),
                                            viewInfo: slot.viewInfo
                                        };

                                        if (self.data.replicate_type === 'NEVER_ENDS') {
                                            newSlot.recurrence_mode = "NEVER_ENDS";
                                        }

                                        var isBooked = self.checkOverlappedBooked(userBookedSlots, newSlot);

                                        if (isBooked == -1) {
                                            var selectedSlots = Object.values(InterviewDataService.flatData.slots);

                                            var isAlreadySlected = selectedSlots.filter(function (selectedSlot) {
                                                return (moment(selectedSlot.start_time).isSame(moment(newSlot.start_time)) &&
                                                    moment(selectedSlot.end_time).isSame(moment(newSlot.end_time)));
                                            });

                                            if (!isAlreadySlected.length) {
                                                InterviewDataService.addSlot(newSlot);
                                            }
                                        }
                                        viewService.init((moment(self.weekStartDate).add('d', 7 * (N))), true);
                                    }
                                }
                            }

                            InterviewDataService.resetAvailabilities();
                            viewService.clearGridAvailabilities();
                            viewService.drawGridAvailabilities();
                            viewService.init((moment(self.weekStartDate)));
                            getInterviewersAvailabilities();
                            viewService.drawAll();

                            self.data.savingCopy = false;
                            self.data.replicate_type = '';
                            self.data.copy_availability_weeks = 1;
                            self.replicateCheckBox = false;
                            delete self.data.ends_on_value;
                            scope.$digest();
                            HNotifications.show({
                                title: $filter("translate")("Success"),
                                desc: $filter("translate")("copied successfully"),
                                icon: "fa-check-circle",
                                type: "success",
                                timeout: 3000
                            });
                        }).catch(function (err) {
                        self.data.savingCopy = false;
                        console.log(err, "err");
                        $alert({
                            content: $filter("translate")("Error while copying process."),
                            placement: 'top',
                            type: 'danger',
                            show: true,
                            container: 'body',
                            templateUrl: "../modules/team_schedule/employer/settings/alerts/save_settings_alert/save_settings_alert.html",
                            duration: 3
                        });
                        $scope.$digest();
                    });
                } else {
                    var savedSlots = self.getCopiedSlots();

                    // - loop on week slots
                    // - calculate number of weeks for that slot
                    // - loop on the calculated weeks
                    // - copy
                    for (var c = 0; c < savedSlots.length; c++) {
                        if (self.data.replicate_type === 'ENDS_ON') {
                            var diff = moment.duration(moment(self.data['ends_on_value']).diff(moment(savedSlots[c]['start_time'])));
                            self.data.copy_availability_weeks = Math.floor(diff.asWeeks());
                        } else if (self.data.replicate_type === 'NEVER_ENDS') {
                            self.data.copy_availability_weeks = 25;
                        }
                        for (var N = 1; N <= self.data.copy_availability_weeks; N++) {
                            var slot = savedSlots[c];
                            var newSlotStart = (moment(slot['start_time']).add('d', 7 * (N))).valueOf();
                            var newSlotEnd = (moment(slot['end_time']).add('d', 7 * (N))).valueOf();

                            var newSlot = {
                                id: "temp_" + N + '_' + Date.now(),
                                start_time: newSlotStart,
                                end_time: newSlotEnd,
                                day: moment(newSlotStart).startOf().valueOf(),
                                viewInfo: slot.viewInfo
                            };

                            if (self.data.replicate_type === 'NEVER_ENDS') {
                                newSlot.recurrence_mode = "NEVER_ENDS";
                            }

                            var selectedSlots = Object.values(InterviewDataService.flatData.slots);

                            var isAlreadySlected = selectedSlots.filter(function (selectedSlot) {
                                return (moment(selectedSlot.start_time).isSame(moment(newSlot.start_time)) &&
                                    moment(selectedSlot.end_time).isSame(moment(newSlot.end_time)));

                            });

                            if (!isAlreadySlected.length) {
                                InterviewDataService.addSlot(newSlot);
                            }
                            viewService.init((moment(self.weekStartDate).add('d', 7 * (N))), true);
                        }
                    }

                    InterviewDataService.resetAvailabilities();
                    viewService.clearGridAvailabilities();
                    viewService.drawGridAvailabilities();
                    viewService.init((moment(self.weekStartDate)));
                    viewService.drawAll();

                    self.data.savingCopy = false;
                    self.data.replicate_type = '';
                    self.data.copy_availability_weeks = 1;
                    self.replicateCheckBox = false;
                    delete self.data.ends_on_value;
                    HNotifications.show({
                        title: $filter("translate")("Success"),
                        desc: $filter("translate")("copied successfully"),
                        icon: "fa-check-circle",
                        type: "success",
                        timeout: 3000
                    });
                }
            }
            else {
                self.data.savingCopy = false;
            }
        };

        self.getCopiedSlots = function () {
            // take the current opened week selected solts.
            var slots = [];
            for (var s in InterviewDataService.flatData['slots']) {
                var slot = InterviewDataService.flatData['slots'][s];
                if (slot.day >= moment(self.weeklyRange.from).valueOf() && slot.day <= moment(self.weeklyRange.to).valueOf()) {
                    slots.push(slot);
                }
            }

            return slots;
        };

        var returnCopiedPeriodAvailabilities = function (type) {
            //TODO : check why interviewers structure have 2 formats
            var interviewersIds = [];
            if (interviewers && interviewers.length) {
                if (interviewers[0].hasOwnProperty('user_id')) {
                    interviewersIds = _.pluck(interviewers, 'user_id');
                } else {
                    interviewersIds = _.pluck(interviewers, 'id');
                }
            }

            return InterviewV2API.getJobInterviewersAvailabilitiesV2(
                self.data.brandId,
                interviewersIds,
                self.weeklyRange.from,
                moment(self.weeklyRange.to).add('d', (7 * self.data.copy_availability_weeks) + 1),
                type
            );
        };

        self.checkOverlappedBooked = function (userBookedSlots, newSlot) {
            var isBooked = userBookedSlots.findIndex(function (bookedSlot) {
                var bookedSLotStart = moment(bookedSlot['start_time']).valueOf();
                var bookedSLotEnd = moment(bookedSlot['end_time']).valueOf();

                return (
                    ((moment(bookedSlot.start_time).isAfter(moment(newSlot.start_time)) || bookedSLotStart === newSlot.start_time))
                    && ((moment(bookedSlot.end_time).isBefore(moment(newSlot.end_time)) || bookedSLotEnd === newSlot.end_time))
                );
            });

            return isBooked;
        };

        self.updateReplicateType = function () {
            if (self.data['replicate_type'] === 'NEVER_ENDS') {
                delete self.data.interview_window;
                self.updateInterviewWindow();
            }
        };

        self.updateInterviewWindow = function () {
            var tempUpdateWindow = function () {
                interview_window = self.data['interview_window'] || 365;
                viewService.setAvailableSlotsEndPeriods(interview_window);
                _emitter.trigger('INTERVIEW_WINDOW_UPDATED');
            };

            if (self.data['interview_window'] !== interview_window) {
                tempUpdateWindow();
            }
        };

        self.updateInterviewDuration = function (isCustom) {
            if (InterviewDataService.hasFutureSlots()) {

                var options = {
                    text: $filter("translate")("Changing slot duration will clear existing slots?"),
                    callback: function (confirmed) {
                        if (confirmed) {
                            onChangeConfirmed(isCustom);
                        } else {
                            revertDurationChange();
                        }
                    },
                    onHide: revertDurationChange
                };

                hConfirm(options);
            } else {
                onChangeConfirmed(isCustom);
            }
        };

        var revertDurationChange = function () {

            if ([15, 30, 60, 90, 120].indexOf(interview_duration) < 0) {
                self.data.interview_duration = 'CUSTOM';
                self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                self.data.custom_duration_minutes = String(interview_duration % 60);
            } else {
                self.data.interview_duration = String(interview_duration);
            }

            scope.$digest();
        };

        var onChangeConfirmed = function (isCustom) {

            if (interview_duration != self.data.interview_duration) {
                interview_duration = self.data.interview_duration;
                if (isCustom || self.data.interview_duration == 'CUSTOM') {
                    interview_duration = parseInt(self.data.custom_duration_hours) + parseInt(self.data.custom_duration_minutes);
                } else {
                    interview_duration = parseInt(self.data.interview_duration);
                    self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                    self.data.custom_duration_minutes = String(parseInt(interview_duration) % 60);
                }

                viewService.clearSlots();
                InterviewDataService.clearSlots();
                viewService.stepSize = interview_duration;
                viewService.drawAll();
            }
        };

        self.setOptional = function (optional) {
            isOptional = !!optional;
        };

        self.clearSlots = function () {
            if (InterviewDataService.hasFutureSlots()) {
                InterviewDataService.clearSlots();
                viewService.clearSlots();
                viewService.drawAll();
            }
        };

        self.triggerInterviewersChanged = function (userInterviewers) {
            if (userInterviewers && userInterviewers.length) {
                interviewers = angular.copy(userInterviewers);
                // load interviewers' available and booked slots
                getInterviewersAvailabilities();
            } else {
                interviewers = [];
                viewService.resetAvailabilities();
                viewService.clearGridAvailabilities();
                InterviewDataService.resetAvailabilities();
                viewService.drawAll();
            }
        };

        self.destroy = function () {
            InterviewDataService.reset();
        };

        var getInterviewersAvailabilities = function () {
            var deferred = $q.defer();

            var availableSlotsPromise = returnAvailabilitiesPromiseByType("AVAILABLE");
            var bookedSlotsPromise = returnAvailabilitiesPromiseByType("BOOKED");
            var availabilityPromises = {available: availableSlotsPromise, booked: bookedSlotsPromise};

            $q.all(availabilityPromises)
                .then(function (response) {
                    var availableSlots = response.available.interviewers;
                    var bookedSlots = response.booked.interviewers;

                    self.availableSlots = availableSlots || [];
                    self.bookedSlots = bookedSlots || [];

                    viewService.resetAvailabilities();
                    InterviewDataService.resetAvailabilities();
                    InterviewDataService.parseAvailabilities(bookedSlots, "BOOKED", interviewers.length);
                    InterviewDataService.parseAvailabilities(availableSlots, "AVAILABLE", interviewers.length);
                    viewService.drawAll();

                    scope.$digest();
                    deferred.resolve();

                }, function (err) {
                    console.error(err);
                    scope.$digest();
                    deferred.reject();
                });

            return deferred.promise;
        };

        var returnAvailabilitiesPromiseByType = function (type) {
            //TODO : check why interviewers structure have 2 formats
            var interviewersIds = [];
            if (interviewers && interviewers.length) {
                if (interviewers[0].hasOwnProperty('user_id')) {
                    interviewersIds = _.pluck(interviewers, 'user_id');
                } else {
                    interviewersIds = _.pluck(interviewers, 'id');
                }
            }
            return InterviewV2API.getJobInterviewersAvailabilitiesV2(
                self.data.brandId,
                interviewersIds,
                self.weeklyRange.from,
                moment(self.weeklyRange.to).add('d', 1),
                type
            );
        };

        self.destroy = function () {
            interviewers = [];
            interview_duration = 15;
            allow_overlap = false;
            isOptional = false;
            InterviewDataService.reset();
            InterviewDataService.resetAvailabilities();
            viewService.resetAvailabilities();
            viewService.destroy();
        };
    }

    angular
        .module('harriApp.interviewV2')
        .service('InterviewCalendarForm', [
            'InterviewDataService', 'brandServices',
            function (InterviewDataService, brandServices) {

                return function (scope, viewService) {
                    return new InterviewCalendarForm(scope, viewService, InterviewDataService, brandServices);
                }
            }]);
})();
